import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import ScoringPage from '../pages/ScoringPage';

export const Scoring = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Evalúa clientes sin historial de crédito con Score Alternativo")}
        description={t('Obtén una puntuación confiable con Score Alternativo, impulsando la inclusión financiera y reduciendo riesgos operativos.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/alternative-scoring' : 'score-alternativo'}`}
        hreflang={[
          { url: "https://dynamicore.io/score-alternativo", lang: "es" },
          { url: "https://dynamicore.io/en/alternative-scoring", lang: "en-us" }
        ]}
      />
      <ScoringPage/>
    </Layout>
  )
}
